var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2231 13C25.2231 19.6274 19.8005 25 13.1115 25C6.42252 25 1 19.6274 1 13C1 6.37258 6.42252 1 13.1115 1C19.8005 1 25.2231 6.37258 25.2231 13Z",
    fill: "white",
    stroke: "url(#paint0_linear_7413_32685)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9549 13.5997C17.9549 13.5997 14.3868 18.3996 13.1102 18.3996C11.8336 18.3996 8.26562 13.5996 8.26562 13.5996M13.1102 17.7996V7.59961",
    stroke: "url(#paint1_linear_7413_32685)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7413_32685",
    x1: 7.01054,
    y1: 2.44046,
    x2: 18.8119,
    y2: 23.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7413_32685",
    x1: 10.6698,
    y1: 8.24781,
    x2: 16.277,
    y2: 16.9609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDownload);
export default __webpack_public_path__ + "static/media/whiteDownload.0260566e989f366cf37f84cfeaeccdc1.svg";
export { ForwardRef as ReactComponent };